<template>
  <nav class="persona-navigation">
    <ul v-if="isPersonaWizard" class="u-reset persona-navigation__steps">
      <li class="persona-navigation__step">
        <tooltip-initiator v-bind="tooltipProps" :label="customWizard.name">
          <template #default="{ hasHover, toggle }">
            <n-link
              :to="localePath({ name: 'wizard' })"
              class="persona-navigation__btn btn btn--secondary btn--bubble"
              @mouseenter.native="hasHover ? null : toggle(true)"
              @mouseleave.native="hasHover ? null : toggle(false)"
              @touchstart.native="hasHover ? toggle(true) : null"
              @touchend.native="hasHover ? toggle(false) : null"
            >
              <responsive-img
                :src="customWizard.icon"
                :width="42"
                alt=""
                class="persona-navigation__icon"
              />
            </n-link>
          </template>
        </tooltip-initiator>
      </li>
    </ul>
    <ul class="u-reset persona-navigation__steps">
      <li
        v-for="{ icon, id, param, name } in personaWizardList"
        :key="id"
        class="persona-navigation__step"
      >
        <tooltip-initiator v-bind="tooltipProps" :label="name">
          <template #default="{ hasHover, toggle }">
            <n-link
              :to="getRouteLink(param)"
              class="persona-navigation__btn btn btn--secondary btn--bubble"
              @mouseenter.native="hasHover ? null : toggle(true)"
              @mouseleave.native="hasHover ? null : toggle(false)"
              @touchstart.native="hasHover ? toggle(true) : null"
              @touchend.native="hasHover ? toggle(false) : null"
            >
              <responsive-img :src="icon" :width="42" alt="" class="persona-navigation__icon" />
            </n-link>
          </template>
        </tooltip-initiator>
      </li>
    </ul>
  </nav>
</template>

<script>
  import { mapState } from 'vuex'
  import { personaList } from '@/assets/js/model/persona'
  import { getImage } from '@/assets/js/util/misc/image'
  import { pageIds } from '@/assets/js/model/page'
  import ResponsiveImg from '@/components/responsive-img/responsive-img'
  import TooltipInitiator from '@/components/tooltip-initiator/tooltip-initiator'

  export default {
    components: { TooltipInitiator, ResponsiveImg },
    props: {},
    computed: {
      ...mapState('navigation', ['meta']),
      isPersonaWizard() {
        return this.meta.pageId === pageIds.PERSONA_WIZARD
      },
      customWizard() {
        return personaList.find(({ isPersona }) => !isPersona)
      },
      personaWizardList() {
        return personaList.filter(({ isPersona, param }) => {
          if (this.isPersonaWizard) {
            return isPersona && this.$route.params.persona !== param
          }

          return isPersona
        })
      },
      tooltipProps() {
        return {
          originPosition: { x: 'start', y: 'center' },
          overlayPosition: { x: 'end', y: 'center' },
          position: ({ height, x, y }) => ({ x: x + 8, y: y + height / 2 }),
          transition: 'trs-to-left',
        }
      },
    },
    methods: {
      getRouteLink(param) {
        return this.localePath({
          name: 'persona-persona',
          params: { persona: param },
        })
      },
    },
    getImage,
  }
</script>

<style lang="scss" src="./_persona-navigation.scss" />
